import React, { useEffect } from 'react';
import { Select } from 'antd';
import useAuthStore from '../../store/authStore';

const SUPER_ROLES = ['developer_admin', 'super_admin'];

const BranchSelect = ({ branches = [], value, onChange, placeholder = 'Şube seçiniz', style, disabled }) => {
  const { user } = useAuthStore();
  const isSuperRole = SUPER_ROLES.includes(user?.role);

  useEffect(() => {
    if (!isSuperRole && user?.branch_id && !value) {
      onChange?.(user.branch_id);
    }
  }, [user?.branch_id, isSuperRole]);

  if (!isSuperRole && user?.branch_id) {
    const branchName = user.branch_name
      || branches.find(b => b.id === user.branch_id)?.name
      || `Şube #${user.branch_id}`;
    return (
      <Select
        value={user.branch_id}
        onChange={onChange}
        style={style}
        disabled
        options={[{ label: branchName, value: user.branch_id }]}
      />
    );
  }

  return (
    <Select
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      style={style}
      disabled={disabled}
      options={branches.map(b => ({ label: b.name, value: b.id }))}
      showSearch
      filterOption={(input, option) =>
        option.label.toLowerCase().includes(input.toLowerCase())
      }
    />
  );
};

export default BranchSelect;
